import React from 'react';

/**
 * RemoveItemWarningModal - Warns user to remove add-on items first
 * @param {Object} item - The item being removed
 * @param {Array} addOnItems - Array of add-on items (half/full) that need to be removed first
 * @param {Object} packageInfo - Information about the package and brand the item belongs to
 * @param {Function} onClose - Callback to close the modal
 */
const RemoveItemWarningModal = ({ item, addOnItems, packageInfo, onClose }) => {
  if (!item || !addOnItems || addOnItems.length === 0) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[100]" onClick={onClose}>
      <div 
        className="bg-white rounded-lg p-6 max-w-md w-full mx-4 shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start mb-4">
          <div className="flex-shrink-0">
            <svg className="h-6 w-6 text-amber-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          <div className="ml-3 flex-1">
            <h3 className="text-lg font-bold text-gray-900">
              Cannot Remove Item
            </h3>
            {packageInfo && (
              <div className="mt-2 bg-gray-50 border border-gray-200 rounded-lg p-3 space-y-1">
                <p className="text-sm text-gray-600">
                  <span className="font-semibold text-gray-900">Package:</span> {packageInfo.packageName}
                </p>
                <p className="text-sm text-gray-600">
                  <span className="font-semibold text-gray-900">Brand:</span> {packageInfo.brandName}
                </p>
              </div>
            )}
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div className="mb-6">
          <p className="text-sm text-gray-700 mb-3">
            Please remove the add-on items first before removing regular items:
          </p>
          
          <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 space-y-2">
            {addOnItems.map((addOnItem, index) => (
              <div key={index} className="flex items-center justify-between text-sm">
                <span className="font-medium text-gray-800">
                  {addOnItem.quantity}x {addOnItem.name_en || addOnItem.name} 
                  <span className="ml-1 text-amber-700 capitalize font-semibold">
                    ({addOnItem.add_on_type})
                  </span>
                </span>
                <span className="text-gray-600">
                  KWD {(parseFloat(addOnItem.price.replace('KWD ', '') || 0) * addOnItem.quantity).toFixed(3)}
                </span>
              </div>
            ))}
          </div>

          <p className="text-xs text-gray-500 mt-3">
            💡 Tip: Click the minus button on the add-on items (Half/Full) in the order summary to remove them first.
          </p>
        </div>

        <button
          onClick={onClose}
          className="w-full py-2 px-4 bg-[#86604D] text-white rounded-lg hover:bg-[#6B4A3A] transition-colors font-semibold"
        >
          Got it
        </button>
      </div>
    </div>
  );
};

export default RemoveItemWarningModal;

